/**
 * Customer-facing product-category labels for the customer portal.
 *
 * Mirror of website/src/components/rental-items/types.ts
 * (CATEGORY_CUSTOMER_LABELS) and backend/pdf/product_labels.py. Keep the three
 * in sync. The portal is customer-facing, so it uses the formal labels; the
 * admin app keeps the colloquial names.
 *
 * NOTE (flagged for client review): roll-off is plural ("containers"),
 * front-loader is singular ("container"). Intentional per request, pending
 * client sign-off.
 */

export const CATEGORY_CUSTOMER_LABELS = {
  roll_off: 'Open-top roll-off containers',
  front_loader: 'Front loader container',
  bulldog_bag: 'Bulldog Bags',
} as const;

/** Classify a product name into a canonical category key, or null. */
function classifyCategory(name: string): keyof typeof CATEGORY_CUSTOMER_LABELS | null {
  const lower = (name || '').toLowerCase();
  if (lower.includes('roll off') || lower.includes('rolloff') || lower.includes('roll-off')) {
    return 'roll_off';
  }
  if (lower.includes('front') && lower.includes('loader')) {
    return 'front_loader';
  }
  if (lower.includes('bulldog')) {
    return 'bulldog_bag';
  }
  return null;
}

/** Customer-facing category label for a product name, or null if unmatched. */
export function categoryLabelForName(name: string): string | null {
  const category = classifyCategory(name);
  return category ? CATEGORY_CUSTOMER_LABELS[category] : null;
}
